export const PICKUP_DATE_TYPES_DB = {
	TODAY: 'Today',
	TOMORROW: 'Tomorrow',
	'NEXT 7 DAYS': 'Next 7 Days',
	'NEXT 90 DAYS': 'Next 90 Days',
};
